// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2SIfa","approved":"Status_approved__2AWj2","rejected":"Status_rejected__1FaqK","expired":"Status_expired__36U_b","label":"Status_label__1mb3I"};